module.exports = __webpack_public_path__ + "img/will.f23bbbee.svg";